import type { SyntheticEvent } from "react";

interface CompanyLogoProps {
  size?: "default" | "large";
  alt?: string;
}

const CompanyLogo = ({
  size = "default",
  alt = "Logo Kropek",
}: CompanyLogoProps) => {
  const isLarge = size === "large";
  const containerClass = `logo-container${isLarge ? " logo-container--large" : ""}`;
  const imageClass = `company-logo${isLarge ? " company-logo--large" : ""}`;

  return (
    <div className={containerClass}>
      <img
        src="/logo.png"
        alt={alt}
        className={imageClass}
        onError={(event: SyntheticEvent<HTMLImageElement>) => {
          event.currentTarget.style.display = "none";
        }}
      />
    </div>
  );
};

export default CompanyLogo;
